import React from "react";
import { Box } from "grommet";
import { DocumentItem } from "./DocumentItem";
export var DocumentList = function DocumentList(_ref) {
  var result = _ref.result;
  return /*#__PURE__*/ React.createElement(
    Box,
    {
      flex: true,
      direction: "column",
      gap: "small",
      margin: {
        vertical: "1rem",
      },
    },
    /*#__PURE__*/ React.createElement(DocumentItem, {
      result: result,
    })
  );
};
